import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const InkstickIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 16;
  const color = props.color || 'black';
  return <Icon name={'inkstick'} size={size} color={color} />;
};

export default React.memo(InkstickIcon);
